import * as React from 'react';
export default function SvgGithub() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 12c0-1.219.3-2.368.832-3.376l-.78-2.57c-.262-.862.66-1.604 1.446-1.162l1.815 1.02A7.216 7.216 0 0112 4.75c1.453 0 2.805.427 3.94 1.163l1.822-1.022c.787-.44 1.71.303 1.445 1.165l-.787 2.572A7.25 7.25 0 114.75 12z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}